
import Vue from 'vue'

export default Vue.extend({
  name: 'Unauthorized',
  methods: {
    goBack() {
      this.$router.back()
    },
    goDashboard() {
      this.$router.push({ name: 'Dashboard' })
    }
  }
})
